import { configureStore } from '@reduxjs/toolkit';
import authReducer from './Slices/AuthSlice';
import companyAdminReducer from './Slices/CompanyAdminSlices';
import profileReducer from './Slices/profileSlice';
import messageCountReducer from './Slices/MessageCountSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profileReducer,
    companyAdmin: companyAdminReducer,
    messageCount: messageCountReducer,
  },
});